module.exports = __webpack_public_path__ + "img/medal.ed73ae7f.svg";